import { Injectable } from '@angular/core';
import { FolderDto, GalleryDto } from '@nusign/picflow-backend-types';

@Injectable({
  providedIn: 'root',
})
export class FolderGalleryFilterService {
  public recursiveFilterFolders(folderId: string, folders: FolderDto[]): FolderDto[] {
    const allFolders = [];
    const validFolders = folders.filter(folder => folder.parent_folder === folderId);
    validFolders.forEach(f => {
      allFolders.push(f);
      allFolders.push(...this.recursiveFilterFolders(f.id, folders));
    });
    return allFolders;
  }

  public filterFoldersAndGalleries(folders: FolderDto[], galleries: GalleryDto[], isSharedWithMe: boolean) {
    if (isSharedWithMe) return { folders, galleries };

    const filteredFolders = this.filterFolders(folders);
    const filteredGalleries = this.filterGalleries(galleries, filteredFolders);

    return { folders: filteredFolders, galleries: filteredGalleries };
  }

  private filterFolders(folders: FolderDto[]) {
    const filteredFolders: FolderDto[] = [];

    folders.forEach(folder => {
      if (folder.parent_folder) return;
      const descendants = this.recursiveFilterFolders(folder.id, folders);
      filteredFolders.push(...descendants, folder);
    });

    return filteredFolders;
  }

  private filterGalleries(galleries: GalleryDto[], filteredFolders: FolderDto[]) {
    return galleries.filter(gallery => {
      if (!gallery.folder) return true;
      return filteredFolders.some(folder => folder.id === gallery.folder);
    });
  }
}
